import { render, staticRenderFns } from "./AboutProduct.vue?vue&type=template&id=237bf4b4&"
import script from "./AboutProduct.vue?vue&type=script&lang=js&"
export * from "./AboutProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports